"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextModule = void 0;

/**
 * A component where an action is triggered
 * @packageDocumentation
 */
let ContextModule;
exports.ContextModule = ContextModule;

(function (ContextModule) {
  ContextModule["aboutTheWork"] = "aboutTheWork";
  ContextModule["artistHeader"] = "artistHeader";
  ContextModule["artistRecentlySold"] = "artistRecentlySold";
  ContextModule["artistsTab"] = "artistsTab";
  ContextModule["artistsToFollowRail"] = "artistsToFollowRail";
  ContextModule["artworkGrid"] = "artworkGrid";
  ContextModule["artworkImage"] = "artworkImage";
  ContextModule["artworkSidebar"] = "artworkSidebar";
  ContextModule["auctionSidebar"] = "auctionSidebar";
  ContextModule["auctionRail"] = "auctionRail";
  ContextModule["auctionResults"] = "auctionResults";
  ContextModule["auctionsInfo"] = "auctionsInfo";
  ContextModule["bannerPopUp"] = "bannerPopUp";
  ContextModule["browseFair"] = "browseFair";
  ContextModule["categoryRail"] = "categoryRail";
  ContextModule["collectionDescription"] = "collectionDescription";
  ContextModule["consignSubmissionFlow"] = "consignSubmissionFlow";
  ContextModule["currentShowsRail"] = "currentShowsRail";
  ContextModule["fairInfo"] = "fairInfo";
  ContextModule["fairsHeader"] = "fairsHeader";
  ContextModule["featuredArtistsRail"] = "featuredArtistsRail";
  ContextModule["footer"] = "footer";
  ContextModule["geneHeader"] = "geneHeader";
  ContextModule["header"] = "header";
  ContextModule["intextTooltip"] = "intextTooltip";
  ContextModule["liveAuctionsRail"] = "liveAuctionsRail";
  ContextModule["mainCarousel"] = "mainCarousel";
  ContextModule["minimalCTABanner"] = "minimalCTABanner";
  ContextModule["otherWorksByArtistRail"] = "otherWorksByArtistRail";
  ContextModule["otherWorksFromPartnerRail"] = "otherWorksFromPartnerRail";
  ContextModule["otherWorksFromShowRail"] = "otherWorksFromShowRail";
  ContextModule["otherWorksInAuctionRail"] = "otherWorksInAuctionRail";
  ContextModule["partnerHeader"] = "partnerHeader";
  ContextModule["pastFairs"] = "pastFairs";
  ContextModule["popUpModal"] = "popUpModal";
  ContextModule["recentlyViewedRail"] = "recentlyViewedRail";
  ContextModule["relatedArtistsRail"] = "relatedArtistsRail";
  ContextModule["relatedWorksRail"] = "relatedWorksRail";
  ContextModule["saveWorksCTA"] = "saveWorksCTA";
  ContextModule["showHeader"] = "showHeader";
  ContextModule["showInfo"] = "showInfo";
  ContextModule["tagHeader"] = "tagHeader";
  ContextModule["worksByPopularArtistsRail"] = "worksByPopularArtistsRail";
  ContextModule["worksForSaleRail"] = "worksForSaleRail";
})(ContextModule || (exports.ContextModule = ContextModule = {}));